import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { CostTrendPoint } from '../../../types/dashboard';

interface CostTrendChartProps {
  data: CostTrendPoint[];
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg p-3">
      <p className="text-xs font-semibold text-slate-300 mb-1">{label}</p>
      {payload.map((entry: any, i: number) => (
        <p key={i} className="text-xs" style={{ color: entry.color }}>
          {entry.name}: Rs {entry.value.toLocaleString('en-IN')}
        </p>
      ))}
    </div>
  );
};

export const CostTrendChart: React.FC<CostTrendChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <AreaChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis dataKey="month" tick={{ fontSize: 11, fill: '#94a3b8' }} />
        <YAxis tick={{ fontSize: 11, fill: '#94a3b8' }} />
        <Tooltip content={<CustomTooltip />} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Area type="monotone" dataKey="material" name="Material" stackId="1" stroke="#38bdf8" fill="#38bdf8" fillOpacity={0.3} />
        <Area type="monotone" dataKey="labor" name="Labor" stackId="1" stroke="#a78bfa" fill="#a78bfa" fillOpacity={0.3} />
        <Area type="monotone" dataKey="service" name="Service" stackId="1" stroke="#34d399" fill="#34d399" fillOpacity={0.3} />
      </AreaChart>
    </ResponsiveContainer>
  );
};
